import type { PostInsights } from '@frontend/gql/social/graphql';
import type { ContentPreviewData } from '../types';

/**
 * Convert ContentPreviewData coming from the content-preview components into
 * the PostInsights shape that downstream analytics components expect.
 *
 * This logic was duplicated in multiple content-preview sheets. Centralising
 * it here eliminates duplication and ensures future changes only need to be
 * made in one place.
 */
export const transformToPostInsights = (content: ContentPreviewData): PostInsights => ({
  __typename: 'PostInsights',
  entityId: content.id,
  memberId: content.creator.id,
  accountEntityId: content.id,
  accountUsername: content.creator.handle,
  entityNetwork: (content.metadata.platform ?? '').toUpperCase(),
  entityType: (content.metadata.contentType ?? '').toUpperCase(),
  mentionId: content.mentionId,
  postDate: content.createdAt,
  postUpdateDate: content.updatedAt,
  postCaption: content.caption,
  postImageUrl: content.mediaUrl,
  postPermalink: content.originalUrl,
  postExternalId: content.postExternalId,
  advertisableMediaPermissions: content.advertisableMediaPermissions,
  member: {
    __typename: 'SocialMember',
    id: content.creator.id,
    name: content.creator.name,
    profilePicture: content.creator.avatarUrl,
    instagramUsername: content.metadata.platform === 'instagram' ? content.creator.handle : null,
    pinterestUsername: content.metadata.platform === 'pinterest' ? content.creator.handle : null,
    tiktokUsername: content.metadata.platform === 'tiktok' ? content.creator.handle : null,
    youtubeUsername: content.metadata.platform === 'youtube' ? content.creator.handle : null,
  },
  total: {
    __typename: 'Insights',
    impressions: content.metrics.impressions,
    engagements: content.metrics.engagement,
    engagementRate: content.metrics.engagementRate,
    tmv: content.metrics.tmv,
  },
});
